<template>
  <div id="app">
    <div class="login-page-wrapper">
      <div class="left-side">
        <div class="logo">
          <a href="/"><img alt="Normann logo" src="../assets/logo.png" /></a>
        </div>
        <Login heading="Login" />
      </div>
      <div class="right-side">
        <LoginSlider />
      </div>
    </div>
  </div>
</template>

<script>
import Login from "../components/Login.vue";
import LoginSlider from "../components/LoginSlider.vue";

export default {
  name: "App",
  components: {
    Login,
    LoginSlider,
  },
};
</script>

<style lang="scss">
.login-page-wrapper {
  display: flex;
  flex-wrap: wrap;
  min-height: 100vh;
  .logo {
    text-align: center;
    padding-top: 202px;
    @media (max-width: 1199px) {
      padding-top: 75px;
    }
  }

  .left-side {
    width: calc(100% - 38.8%);
    padding: 0 20px 100px;
    @media (max-width: 1199px) {
      width: 50%;
    }
    @media (max-width: 991px) {
      width: 100%;
      margin-bottom: 40px;
    }
  }
  .right-side {
    width: 38.8%;
    @media (max-width: 1199px) {
      width: 50%;
    }
    @media (max-width: 991px) {
      width: 100%;
    }
  }
}

.btn-wrap {
  button {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: #ffffff;
    background-color: #000000;
    border: 0;
    min-width: 245px;
    min-height: 65px;
    padding: 15px;
  }
}
</style>
